module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title_tp"
  }, [_vm._v("WINSTON S. CHURCHILL")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "author_byline"
  }, [_vm._v("b"), _c('span', {
    staticClass: "small"
  }, [_vm._v("y")])]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILBERT")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLUME")]), _vm._v(" IV")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle_main"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle_tp"
  }, [_vm._v("1916–1922")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("Hillsdale College Press")]), _vm._v(" "), _c('p', {
    staticClass: "publisher1"
  }, [_vm._v("RosettaBooks")]), _vm._v(" "), _c('p', {
    staticClass: "publisher1"
  }, [_vm._v("2015")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fb58e3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 60
// module chunks = 0